<template>
    <q-select
        class="mw-form-v2-select"
        :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense" v-model="fieldValue"
              ref="selectlo"
              use-input
              :options="options"
              emit-value
              option-value="title"
              option-label="title"
              map-options
              @filter="filterFn"
              clearable

              :loading="isLoading"
              :label="field.layout_injected_label ? field.layout_injected_label : field.label"
              :rules="field.required ? [ val => val && val.length > 0  || requiredText] : []"
    >


      <template v-slot:selected>
        <div
            v-if="fieldValue"
            class="text-body2 q-my-none q-ml-none q-mr-none"
        >
         {{ fieldValue }}
        </div>
      </template>

      <template v-slot:option="scope">
          <q-item v-bind="scope.itemProps">
            <q-item-section avatar>
              <q-img
                  fit="contain"
                  :src="(form.domain === 'https://mortgageware.dev' ? 'http://localhost:9001' : form.domain) + scope.opt.image"
                  spinner-color="blue"
                  style="height: 40px; max-width: 40px"
              />
            </q-item-section>
            <q-item-section>
              <q-item-label>{{ scope.opt.title }}</q-item-label>
              <q-item-label caption>{{ scope.opt.description }}</q-item-label>
              <q-item-label caption v-if="scope.opt.nmls_id">NMLS ID: {{ scope.opt.nmls_id }}</q-item-label>
            </q-item-section>
          </q-item>
    </template>

      <template v-slot:append>
        <q-icon name="s_person" />
      </template>
       <template v-slot:label>
         {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
      </template>
    </q-select>

</template>

<script>

import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
import OptionalLabel from "@/components/OptionalLabel";

export default {
  props: {
    modelValue: {},
    field:{}
  },
  components: {OptionalLabel},
  data() {
    return {
      value: null,
      options: null,
      loById: {}
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      getLoanOfficers: 'lo/lo/default',
    }),
    filterFn (val, update) {
      if (val === '') {
        update(() => {
          if(this.loan_officers) {
            this.options = this.loan_officers
          } else {
            this.options = [];
          }

          // here you have access to "ref" which
          // is the Vue reference of the QSelect
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase();
        if(this.loan_officers) {
          this.options = this.loan_officers.filter(v => v.title.toLowerCase().indexOf(needle) > -1)
        } else {
          this.options = [];
        }
    })
    },
  },
  watch: {
    loan_officers: function (los) {
      //console.log('loan_officers changed');
      for(let key in los) {
        this.loById[los[key].id] = los[key].title;
      }
    },
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    ...mapFields('settings/list', {
      form: 'form'
    }),
    ...mapFields('lo/lo', {
      error: 'error',
      loan_officers: 'loan_officers',
      isLoading: 'isLoading'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select loan officer';
    },
    optionsForSelect: function () {
      let data = [];
      for (const [key, value] of this.loan_officers) {
        data.push( {
          label: value,
          value: key
        });
      }
      return data;
    },
    fieldValue: {
      get() {
        // if(!this.loan_officers) {
        //   return [];
        // }
        return this.modelValue;
      },
      set(value) {
        // if(!this.loan_officers) {
        //   return;
        // }
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {
    if(!this.loan_officers) {
      this.getLoanOfficers("");
    } else {
      for(let key in this.loan_officers) {
        this.loById[this.loan_officers[key].id] = this.loan_officers[key].title;
      }
    }

  }
}
</script>
